import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Header } from '../../components/shared/header/header';
import { ReportsCard } from '../../components/reports-card/reports-card';
import { ChatbotBubble } from '../../components/shared/chatbot-bubble/chatbot-bubble';
import { CollapsibleMaskCard } from '../../components/collapsible-mask-card/collapsible-mask-card';
import { ReportPageContextService } from '../../services/report-page-context.service';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    Header,
    ReportsCard,
    ChatbotBubble,
    CollapsibleMaskCard
  ],
  templateUrl: './reports.html',
  styleUrls: ['./reports.scss']
})
export class Reports implements OnInit, OnDestroy {
  areCardsCollapsed: boolean = false;
  currentRoute: string = '';
  private routerSubscription?: Subscription;

  reportsCards = [
  {
    id: 'dealer',
    borderColor: '#001E50',
    title: 'Raio X - Dealer',
    content: 'Análise completa do desempenho do dealer com métricas detalhadas de vendas, estoque e performance comercial.',
    route: '/reports/dealer',
    hasMask: false // ← SEM máscara
  },
  {
    id: 'comission',
    borderColor: '#1A92EC',
    title: 'Comission Reports',
    content: 'Relatórios detalhados de comissões por vendedor, período e modelo de veículo com cálculos automatizados.',
    route: '/reports/comission',
    hasMask: false // ← SEM máscara
  },
  {
    id: 'simulator',
    borderColor: '#0040C5',
    title: 'Simulador de Comissionamento',
    content: 'Relatórios detalhados de comissões por vendedor, período e modelo de veículo com cálculos automatizados.',
    route: '/reports/simulator',
    hasMask: false // ← SEM máscara
  },
  {
    id: 'nfs',
    borderColor: '#3D8872',
    title: 'Comission NFs',
    content: 'Notas fiscais vinculadas às comissões com status de pagamento e histórico completo de transações.',
    route: '/reports/nfs',
    hasMask: true // ← COM máscara
  },
  {
    id: 'leads',
    borderColor: '#6A767D',
    title: 'Leads Reports',
    content: 'Dashboard completo de leads com taxas de conversão, origens e performance por canal de captação.',
    route: '/reports/leads',
    hasMask: true // ← COM máscara
  }
];

  constructor(private router: Router, private reportPageContext: ReportPageContextService) {}

  ngOnInit(): void {
    // Verificar rota inicial
    this.currentRoute = this.router.url;
    this.updateCardsState(this.currentRoute);

    // Observar mudanças de rota
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute = event.url;
        this.updateCardsState(this.currentRoute);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateCardsState(url: string): void {
    // Cards expandidos quando está em /reports (sem sub-rota)
    // Cards colapsados quando está em uma sub-rota (/reports/dealer, etc)
    this.areCardsCollapsed = url !== '/reports' && url.startsWith('/reports/');
    this.reportPageContext.setTitle(this.getComponentTitle());
  }

onSeeMoreClick(cardId: string): void {
  const card = this.reportsCards.find(c => c.id === cardId);

  // Se o card tem máscara, não faz nada
  if (card && card.hasMask) {
    return;
  }

  if (card) {
    this.router.navigate([card.route]);
  }
}
  onCloseClick(): void {
    this.router.navigate(['/reports']);
  }

  getSelectedCard(): any {
    if (this.currentRoute === '/reports' || !this.currentRoute.startsWith('/reports/')) {
      return null;
    }

    // Extrair o id da rota (ex: /reports/dealer -> dealer)
    const routeId = this.currentRoute.replace('/reports/', '');
    return this.reportsCards.find(c => c.id === routeId);
  }

  getComponentTitle(): string {
    const card = this.getSelectedCard();
    return card ? card.title : '';
  }

  getSelectedCardColor(): string {
    const card = this.getSelectedCard();
    return card ? card.borderColor : '#001E50';
  }

  showComponentHeader(): boolean {
    return this.areCardsCollapsed && this.getSelectedCard() !== null;
  }

  // APENAS ESTE MÉTODO FOI ADICIONADO
  getTrackingConfig(card: any): any {
    switch (card.id) {
      case 'dealer':
        return {
          trackEvent: 'raiox',
          trackCategory: 'reports',
          trackLabel: 'ver_raiox_dealer'
        };
      case 'comission':
        return {
          trackEvent: 'commission_reports',
          trackCategory: 'reports',
          trackLabel: 'ver_commission_reports'
        };
      case 'nfs':
        return {
          trackEvent: 'commission_NF',
          trackCategory: 'reports',
          trackLabel: 'ver_commission_nf'
        };
      case 'leads':
        return {
          trackEvent: 'leads_reports',
          trackCategory: 'reports',
          trackLabel: 'ver_leads_reports'
        };
      default:
        return {
          trackEvent: 'reports_card_click',
          trackCategory: 'reports',
          trackLabel: 'ver_reports'
        };
    }
  }
}
